import { defineMessages } from 'react-intl';

const _default_1: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.linkPickerButton.label',
		defaultMessage: 'Add link',
		description: 'Link picker button label within the Prompt screen',
	},
});
export default _default_1;
